var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "download-list" },
    [
      _c(
        "Poptip",
        { attrs: { placement: "bottom-end", offset: 12, width: "300" } },
        [
          _c(
            "Badge",
            { staticClass: "header-badge", attrs: { count: _vm.messageCount } },
            [_c("svg-icon", { attrs: { "icon-class": "filedownload" } })],
            1
          ),
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _vm.$d.fileList.length > 0
              ? _c(
                  "ul",
                  _vm._l(_vm.fileList, function(file) {
                    return _c("download-item", {
                      key: file.time,
                      attrs: { file: file }
                    })
                  }),
                  1
                )
              : _c("p", { staticStyle: { "text-align": "center" } }, [
                  _vm._v(" No downloading files ")
                ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }